/**
 * @flow
 * @relayHash a54e295e8364fba78ea4bfea13539e31
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SolicitationSearchableContractorDropdownQueryVariables = {|
  first?: ?number,
  contractorName?: ?string,
  excludeInSolicitation?: ?string,
|};
export type SolicitationSearchableContractorDropdownQueryResponse = {|
  +contractorsByOrg: ?{|
    +edgeCount: ?number,
    +totalCount: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +fullName: ?string,
        +lastName: ?string,
        +representativeImageUrl: ?string,
      |}
    |}>,
  |}
|};
export type SolicitationSearchableContractorDropdownQuery = {|
  variables: SolicitationSearchableContractorDropdownQueryVariables,
  response: SolicitationSearchableContractorDropdownQueryResponse,
|};
*/


/*
query SolicitationSearchableContractorDropdownQuery(
  $first: Int
  $contractorName: String
  $excludeInSolicitation: String
) {
  contractorsByOrg(first: $first, orderBy: "fullName", contractorName: $contractorName, excludeInSolicitation: $excludeInSolicitation, excludeWithConflicts: true, includeInactive: false) {
    edgeCount
    totalCount
    edges {
      node {
        id
        fullName
        lastName
        representativeImageUrl
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "contractorName",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "excludeInSolicitation",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "contractorsByOrg",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contractorName",
        "variableName": "contractorName"
      },
      {
        "kind": "Variable",
        "name": "excludeInSolicitation",
        "variableName": "excludeInSolicitation"
      },
      {
        "kind": "Literal",
        "name": "excludeWithConflicts",
        "value": true
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Literal",
        "name": "includeInactive",
        "value": false
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": "fullName"
      }
    ],
    "concreteType": "ContractorNodeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "edgeCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractorNodeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractorNode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "representativeImageUrl",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SolicitationSearchableContractorDropdownQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SolicitationSearchableContractorDropdownQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SolicitationSearchableContractorDropdownQuery",
    "id": null,
    "text": "query SolicitationSearchableContractorDropdownQuery(\n  $first: Int\n  $contractorName: String\n  $excludeInSolicitation: String\n) {\n  contractorsByOrg(first: $first, orderBy: \"fullName\", contractorName: $contractorName, excludeInSolicitation: $excludeInSolicitation, excludeWithConflicts: true, includeInactive: false) {\n    edgeCount\n    totalCount\n    edges {\n      node {\n        id\n        fullName\n        lastName\n        representativeImageUrl\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '06b0e60829a46061547aa9fccb10b834';
module.exports = node;
